import React from 'react';
import ntcogLogo from '@features/auth/components/login/ntcog-logo.png';
import { APP_BRAND_SUBTITLE, APP_BRAND_TITLE } from '@core/config/branding';

interface AppBrandProps {
  className?: string;
  title?: string;
  subtitle?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  logoFrameClassName?: string;
  compact?: boolean;
}

const AppBrand: React.FC<AppBrandProps> = ({
  className = '',
  title = APP_BRAND_TITLE,
  subtitle = APP_BRAND_SUBTITLE,
  titleClassName = '',
  subtitleClassName = '',
  logoFrameClassName = '',
  compact = false,
}) => {
  const frameSize = compact ? 40 : 52;
  const logoSize = compact ? 40 : 52;

  return (
    <div
      className={`d-flex align-items-stretch gap-3 min-w-0 ${className}`.trim()}
      aria-label={`${title} ${subtitle}`}
    >
      <div
        className={`d-flex align-items-center justify-content-center flex-shrink-0 ${logoFrameClassName}`.trim()}
        style={{
          width: frameSize,
          minWidth: frameSize,
          height: frameSize,
          alignSelf: 'center',
        }}
      >
        <img
          src={ntcogLogo}
          alt=""
          aria-hidden="true"
          style={{
            width: logoSize,
            height: logoSize,
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </div>

      <div className="d-flex flex-column justify-content-center min-w-0">
        <div
          className={titleClassName}
          style={{
            fontWeight: 700,
            letterSpacing: 1,
            fontSize: compact ? 16 : 18,
            lineHeight: 1.05,
          }}
        >
          {title}
        </div>
        <div
          className={subtitleClassName}
          style={{
            fontSize: compact ? 11 : 12,
            lineHeight: 1.15,
          }}
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
};

export default AppBrand;
